import classNames from "classnames";
import React from "react";
import { FieldValues, useFormContext } from "react-hook-form";
import { CgSpinnerAlt } from "react-icons/cg";

type props = {
  children: React.ReactNode;
  variant?: "outlined" | "link" | "secondary";
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  isPending: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

function SubmitButton({
  children,
  fullWidth,
  variant,
  type,
  disabled,
  isPending,
  ...otherProps
}: props) {
  return (
    <button
      type="submit"
      {...((isPending || disabled) && { disabled: true })}
      className={classNames("button", fullWidth ? "w-full" : "w-auto")}
      {...otherProps}
    >
      {isPending && (
        <CgSpinnerAlt className="h-6 w-auto animate-spin text-wosm-600" />
      )}
      {children}
    </button>
  );
}

export default SubmitButton;
